import type {
  PatientUserInfo,
  SessionClient,
  StorageClient,
  UserInfo,
  UserPatient,
} from "@phurshell/psiapp-frontend-core/domain";
import { queryClient } from "@/di/queryClient";
import { useNewAppointmentStore } from "@/store/useNewAppointmentStore";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useRegisterStore } from "@/store/useRegisterStore";

// Versão do paciente: usa UserPatient/PatientUserInfo (como o psiapp-reactnative-user)
export class SessionClientAdapter implements SessionClient {
  constructor(
    private readonly sessionStorage: StorageClient<UserPatient>,
    private readonly authTokenStorage: StorageClient<string>,
    private readonly userInfoStorage: StorageClient<PatientUserInfo>,
  ) {}

  saveSession(params: UserPatient): void {
    this.sessionStorage.save("session", params);
  }

  getSession(): UserPatient | null {
    return this.sessionStorage.get("session");
  }

  updateSession(params: Partial<UserPatient>): void {
    this.sessionStorage.update("session", params);
  }

  destroySession(): void {
    this.sessionStorage.remove("session");
    this.authTokenStorage.remove("token");
    this.userInfoStorage.remove("user_info");
    useOffcanvasStore().clear();
    useNewAppointmentStore().clear();
    useRegisterStore().clear();
    // exclusivo do main: não deixar dados do usuário anterior no cache do vue-query
    queryClient.clear();
  }

  saveAuthToken(token: string): void {
    this.authTokenStorage.save("token", token);
  }

  getAuthToken(): string {
    return this.authTokenStorage.get("token") || "";
  }

  getUserInfo(): UserInfo | null {
    return null;
  }

  getPatientUserInfo(): PatientUserInfo | null {
    return this.userInfoStorage.get("user_info");
  }

  updateUserInfo(params: Partial<PatientUserInfo>): void {
    this.userInfoStorage.update("user_info", params);
  }
}
